import { render } from "./PharmacyStageView.vue?vue&type=template&id=6b9d3c7b"
import script from "./PharmacyStageView.vue?vue&type=script&lang=js"
export * from "./PharmacyStageView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__